export default {
    path: '/login',
    name: 'login',
    component: () =>
        import(/* webpackChunkName: "login" */ '@/views/auth/Login.vue'),
    meta: {
        layout: 'simple-layout',
        guest: true,
    },
}
